;(async () => {
  const { default: Swiper } = await import('../../plugins/swiper/swiper')
  import('../../plugins/swiper/swiper.scss')

  Promise.all([import(/* webpackMode: "eager" */ './park-detail-carousel.scss')]).then(() => {
    $('.widget.park-detail-carousel').each(function (i, el) {
      $(el).data('widget', new ParkDetailCarousel(el, Swiper))
      $(el).data('widget').init()
    })
  })
})()

function ParkDetailCarousel(el, Swiper) {
  const self = this
  self.el = $(el)

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('ParkDetailCarousel init', self)
    }
    self.el.css('opacity', 1)

    self.el.removeClass('loading')

    const slides = self.el.find('.swiper-slide').length
    if (slides > 1) {
      self.swiper = new Swiper(self.el.find('.swiper-container'), {
        loop: true,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
        },
        on: {
          init: function () {
            setTimeout(function () {
              if ($(window).width() >= 768) {
                if (self.el.find('video').length && self.el.find('video').hasClass('autoplay')) {
                  self.el.find('video').get(0).play()
                  self.el.find('.pause').removeClass('paused')

                  self.el.find('video').get(0).onended = function () {
                    self.el.find('.pause').addClass('paused')
                  }
                }

                if (self.el.find('video').length && !self.el.find('video').hasClass('autoplay')) {
                  self.el.find('.pause').addClass('paused')
                }
              }
            }, 1000)

            if (self.el.find('video').length) {
              self.el.addClass('hide-dots')
            }
          },
        },
      })

      self.swiper.on('slideChangeTransitionEnd', function () {
        if (self.el.find('video').length && self.swiper.realIndex === 0) {
          self.el.addClass('hide-dots')
        } else {
          self.el.removeClass('hide-dots')
        }

        if (self.el.find('video').length) {
          self.el.find('video').each(function (i, el) {
            $(el).get(0).pause()
            self.el.find('.pause').addClass('paused')

            $(el).get(0).onended = function () {
              self.el.find('.pause').addClass('paused')
            }
          })
        }
      })
    } else {
      self.el.find('.swiper-pagination, .swiper-button-next, .swiper-button-prev').hide()
      setTimeout(function () {
        if ($(window).width() >= 768) {
          if (self.el.find('video').length && self.el.find('video').hasClass('autoplay')) {
            self.el.find('video').get(0).play()
            self.el.find('.pause').removeClass('paused')

            self.el.find('video').get(0).onended = function () {
              self.el.find('.pause').addClass('paused')
            }
          }

          if (self.el.find('video').length && !self.el.find('video').hasClass('autoplay')) {
            self.el.find('.pause').addClass('paused')
          }
        }
      }, 1000)
    }

    $('body').on('click', '.pause', function (e) {
      e.preventDefault()
      const video = $(this).parents('.video-container').find('video').get(0)

      $(this).toggleClass('paused')
      if ($(this).hasClass('paused')) {
        video.pause()
      } else {
        video.play()
      }
    })
  }
}
